import React, { createContext, useContext, useState } from 'react'
import { LayoutContainer } from './styledComponents'
import SupportSidebar from './SupportSidebar'
import SupportRoutesHandler from './SupportRoutesHandler'
import DocsideCmsContextProvider from 'src/supportPortal/context/DocsideCmsContextProvider'
import SupportFooter from '../components/footer/SupportFooter'

export const SupportContext = createContext()

export default function SupportPortalLayout() {
  const [showSupportSidebar, setShowSupportSidebar] = useState(false)

  function toggleSidebar() {
    setShowSupportSidebar((prev) => !prev)
  }

  return (
    <LayoutContainer>
      <SupportContext.Provider value={{ toggleSidebar }}>
        <DocsideCmsContextProvider>
          {showSupportSidebar && <SupportSidebar />}
          <SupportRoutesHandler isShowingSidebar={showSupportSidebar} />
          <SupportFooter />
        </DocsideCmsContextProvider>
      </SupportContext.Provider>
    </LayoutContainer>
  )
}
